<template>
  <div>
      <parameter v-for="parameter in parameters"
          v-bind:key="parameter.id"
          :name="parameter.name"
          :input="parameter.input"
          @select="select(parameter.id, $event)"
          :value="localSelected[parameter.id]"
          :options="parameter.options"
          :default_value="parameter.default_value"
          :disabled="disabled"
      >
      </parameter>
  </div>
</template>

<script>
  import Parameter from "@/components/train_configs/Parameter";
  export default {
    name: "Parameters",
    components: {Parameter},
    props: {
      'all_parameters': {required: true},
      /** May be undefined until the model bucket exists; use localSelected in template. */
      'selected_options': {required: false, default: undefined},
      'advanced': {required: false, default: false},
      'disabled': {type: Boolean, default:false},
    },
    methods: {
      select(parameter_id, value) {
        this.$emit('select', {'parameter_id': parameter_id, 'value': value})
      }
    },
    computed: {
      /** Parent may pass undefined before the model bucket exists; [] was wrongly used and breaks prop access. */
      localSelected() {
        const o = this.selected_options;
        if (o == null || Array.isArray(o) || typeof o !== 'object') {
          return {};
        }
        return o;
      },
      parameters () {
        if(this.advanced) {
          return this.advanced_parameters;
        }
        else {
          return this.normal_parameters;
        }
      },
      advanced_parameters () {
        if(!this.all_parameters) {
          return []
        }
        return this.all_parameters.filter((parameter) => {
          return parameter.advanced && parameter.id !== 'required_labels';
        });
      },
      normal_parameters() {
        if(!this.all_parameters) {
          return []
        }
        return this.all_parameters.filter((parameter) => {
          return !parameter.advanced && parameter.id !== 'required_labels';
        });
      }
    },
    data() {
      return {
        'show_advanced': false
      }
    }
  }
</script>

<style scoped>

</style>